export const GetYears = (_moments) => {
    const first = new Date(_moments[0].date);
    const last = new Date(_moments[_moments.length - 1].date);
    const _years = [];

    // Create empty container for Years & Months
    for (let i = first.getFullYear(); i < last.getFullYear() + 1; ++i) {
        const _year = {
            year: i,
            isFirst: i === first.getFullYear(),
            isLast: i === last.getFullYear(),
            isVisible: false,
            months: [],
            moments: [],
        };
        // Create empty month containers
        const startMonth = _year.isFirst ? first.getMonth() : 0;
        const endMonth = _year.isLast ? last.getMonth() + 1 : 12;
        for (let m = startMonth; m < endMonth; ++m) {
            _year.months.push({
                month: m,
                moments: [],
            });
        }
        _years.push(_year);
    }

    // Populate years & months with moments
    _moments.map((_moment) => {
        const date = new Date(_moment.date);
        const year = _years.find((_year) => _year.year === date.getFullYear());
        const month = year.months.find((_month) => _month.month === date.getMonth());
        year.hasMoments = true;
        year.moments.push(_moment.id);
        month.moments.push(_moment.id);
        return null;
    });

    return _years;
};
